import React from "react";

export default function useBoolean(value: boolean) {
    const [state, setState] = React.useState(value)
    const [toggleState] = React.useState(() => {
        return () => setState(b => !b)
    })
    return [state, toggleState, setState] as [ boolean, () => void, React.Dispatch<React.SetStateAction<boolean>>]
}
